import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { selectThemeMode } from '../../../redux/slices/themeSlice';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';
import { BodyMedium } from '../../../components/Texts';
import StoreButtons from '../../../components/StoreButtons';

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  z-index: 1;
  min-height: 250px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: 0px;
    padding-top: 40px;
  }
`;

const BlueCircle = styled.div`
  position: absolute;
  z-index: 0;
  width: 1000px;
  height: 1000px;
  pointer-events: none;
  top: -700px;
  background: red;
  background: radial-gradient(
    circle,
    ${({ theme }) => theme.primary.primary}50 0%,
    ${({ theme }) => theme.primary.primary}00 70%
  );
  border-radius: 50%;
  @media ${PHONE_MEDIA_QUERY} {
    background: radial-gradient(
      circle,
      ${({ theme }) => theme.primary.primary}40 0%,
      ${({ theme }) => theme.primary.primary}00 50%
    );
  }
`;

const DownloadAppModal = ({ onClose }) => {
  const { t } = useTranslation();
  const themeMode = useSelector(selectThemeMode);

  return (
    <Modal onClose={onClose} customStyle={{ overflow: 'hidden' }}>
      <InnerContainer>
        <BlueCircle />
        <img
          style={{
            width: '90%',
            maxWidth: '200px',
          }}
          src={
            themeMode === 'light'
              ? '/logo-footer.webp'
              : '/logo-footer-dark.webp'
          }
          alt='Deks Logo'
        />
        <BodyMedium>{t('downloadAppModal.hint')}</BodyMedium>
        <StoreButtons />
      </InnerContainer>
    </Modal>
  );
};

export default DownloadAppModal;
